/**
 * Rudrik client-side file validation.
 * Enforces the same rules as the backend so users get instant feedback:
 *   • JPG / JPEG / PNG only
 *   • <5 MB
 *
 * Usage:
 *   const error = validateImage(file);
 *   if (error) toast.error(error);
 */
const ALLOWED_MIME = ["image/jpeg", "image/jpg", "image/png"];
const MAX_BYTES = 5 * 1024 * 1024;

export function validateImage(file) {
  if (!file) return "Please choose a file";
  if (!ALLOWED_MIME.includes((file.type || "").toLowerCase())) {
    return "Invalid file type. Only JPG / JPEG / PNG are allowed.";
  }
  if (file.size > MAX_BYTES) {
    return `File too large (${(file.size / 1024 / 1024).toFixed(1)} MB). Maximum size: 5 MB`;
  }
  if (file.size < 100) {
    return "File is too small to contain a valid image";
  }
  return null;
}

/**
 * Mask an Aadhaar number for safe display.
 * "123456789012" → "XXXX-XXXX-9012"
 */
export function maskAadhaar(value) {
  if (typeof value !== "string") return "";
  const digits = value.replace(/\D/g, "");
  if (digits.length !== 12) return "";
  return `XXXX-XXXX-${digits.slice(-4)}`;
}

export function maskPan(value) {
  if (typeof value !== "string" || value.length !== 10) return "";
  return `${value.slice(0, 4)}****${value.slice(-1)}`;
}
